var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 12.724,
    viewBox: "0 0 18 12.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1785",
    "data-name": "Rectangle 1785",
    width: 18,
    height: 12.723,
    fill: "#474747"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661",
    transform: "translate(-77 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(77 444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M118.742,68.721v.4H114.1v-.4c0-.134,0-.269-.012-.4a7.057,7.057,0,0,0-2.111-4.669c.086.005.174.008.261.008a4.4,4.4,0,0,0,1.94-.448,4.265,4.265,0,0,0,.449-.253A4.06,4.06,0,0,0,115,62.69a6.686,6.686,0,0,1,3.74,6.031",
    transform: "translate(-100.742 -56.399)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M105.07,3.727a2.725,2.725,0,0,1-4.091,2.359,4.323,4.323,0,0,0,0-4.719,2.725,2.725,0,0,1,4.091,2.359",
    transform: "translate(-90.846 -0.9)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M11.855,68.29v.4H0v-.4a6.683,6.683,0,0,1,3.841-6.079,4.314,4.314,0,0,0,2.661.916A4.334,4.334,0,0,0,7.555,63c.073-.018.144-.038.216-.06.131.033.261.07.387.113q.238.08.466.181a5.511,5.511,0,0,1,3.217,4.657c.01.132.015.267.015.4",
    transform: "translate(0 -55.968)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M42.274,2.827A2.8,2.8,0,0,1,42,4.036a2.847,2.847,0,0,1-.54.772,2.791,2.791,0,0,1-.682.511c-.059.032-.119.062-.181.088a2.794,2.794,0,0,1-1.147.247h-.005a2.826,2.826,0,1,1,2.827-2.827",
    transform: "translate(-32.945 0)",
    fill: "#474747"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPerson);
export default __webpack_public_path__ + "static/media/two_person.36f3e048de54118ac8fbf000f8c93dab.svg";
export { ForwardRef as ReactComponent };